import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { TeacherData, TeacherService } from '../../services/teacher.service';
import { Utils } from '../../util';
import { ActivatedRoute } from '@angular/router';
import { toast } from 'angular2-materialize';

@Component({
  selector: 'app-update-teacher',
  templateUrl: './update-teacher.component.html',
  styleUrls: ['./update-teacher.component.css']
})
export class UpdateTeacherComponent implements OnInit {
  id: string;
  form: FormGroup;
  assignmentsSelect: {value: string, name: string}[];
  assignments: string[] = [];
  assignment: string = '';

  pickadateParams = Utils.pickadateParams();

  constructor(
    private service: TeacherService,
    private data: TeacherData,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute
  ) {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.assignmentsSelect = Object.keys(data.assignments).map(key => {
      return {value: key, name: data.assignments[key]}
    });
   this.assignment = this.assignmentsSelect[0].value;
  }

  ngOnInit() {
    this.createForm();
    let sub = this.service.getTeacher(this.id).subscribe((teacher) => {
      sub.unsubscribe();
      // console.log(teacher);
      let {name, family, birthdate, semester, assignments} = teacher;
      this.form.setValue({name, family, birthdate, semester});
      this.assignments = assignments;
      // this.selectedIds = [prVntaRef.id];
    });
  }
  createForm() {
    this.form = this.fb.group({
      name: ['', Validators.required],
      family: ['', Validators.required],
      birthdate: ['', Validators.required],
      semester: [1, [Validators.required, Validators.min(1), Validators.max(12)]],
    });
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    let teacher = {
      assignments: this.assignments,
       ...value
    }

    this.service.updateTeacher(this.id, teacher);
    this.service.windowReplace('read');
  }

  touchAssignment(){
    if(this.assignments.includes(this.assignment)) return toast('You can not add duplicates.', 3000);
    this.assignments.push(this.assignment);
  }
  removeAssignment(index: number){
    this.assignments.splice(index, 1);
  }
}
